export const config = {
  reloadOnNotFoundPath: process.env.REACT_APP_DISABLE_NOT_FOUND_RELOAD ? false : true,
}
